<template>
  <div class="c-skeleton-loader" :class="`c-skeleton-loader--${type}`" :style="{ height: height, width: computedWidth, 'border-radius': borderRadius }">

  </div>
</template>

<script>
  export default {
    name: 'SkeletonLoader',

    props: {
      type: {
        type: String,
        default: 'text',
        validator: value => ['text'].includes(value)
      },
      height: {
        type: String,
        default: '1rem'
      },
      width: {
        type: String,
        default: '100%'
      },
      borderRadius: {
        type: String
      },
      hasRandomWidth: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      computedWidth () {
        return this.hasRandomWidth ? this.getRandomInt(25, 75) + '%' : this.width
      }
    },

    methods: {
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
      }
    }
  }
</script>
